module.exports = __webpack_public_path__ + "c2h4static/img/report-img-egg-03-pre@2x.c021a49.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs/report-img-egg-03-pre@2x.png
// module id = r31s
// module chunks = 1